import { useContext } from 'react';
import { ObjectsChartsDataContext } from '../contexts/ObjectsChartsDataContext';

export const useObjectsChartsDataContext = () => {
    return useContext(ObjectsChartsDataContext);
};
